export default __webpack_public_path__ + "static/media/pop.abe7efa2.mp3";